import React from 'react';
import styles from './notification-card.scss';

const NotificationCard = props => {
    const { label, title, hint, btnTxt, btnClick, Icon, updateRef,profileObj } = props;
    return (
        <div className="no-price-borders" ref={ref => updateRef(ref)}>
            <div className={styles["no-price-container"]}>
                <div className={`${styles["title"]} ${(label==="scoreLessThanHundred" || (profileObj.isRE && profileObj.isSO && profileObj.isSer) || (profileObj.isRE && !profileObj.isSO && profileObj.isSer))  ? styles["truntClass"] : ""}`}>{title}</div>
                <div className={`${styles["bodyContainer"]} ${(label==="scoreLessThanHundred" || (profileObj.isRE && profileObj.isSO && profileObj.isSer) || (profileObj.isRE && !profileObj.isSO && profileObj.isSer)) ? styles["truntBody"] : ""}`}>
                    <div className={styles["data-container"]}>
                        <div className={styles["hint"]}>{hint}</div>
                        <button className={styles["price-btn"]} onClick={() => {
                            btnClick()
                        }}>
                            {btnTxt + ' '}<div aria-hidden="true" className="icon-holder arrowIcnHold"><i className="icon-key-left" /></div>
                        </button>
                    </div>
                    <div aria-hidden="true" className={`${styles["icon-container"]} `}>
                        {<Icon />}
                    </div>
                </div>
            </div>
        </div>
    )
};

export default NotificationCard;